import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=4fc1e296&"
import script from "./Inquiry.vue?vue&type=script&lang=js&"
export * from "./Inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports